import React, { useContext, useEffect, useMemo, useState } from "react";
import "./index.css";
import { Controller, useForm } from "react-hook-form";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import CreatableSelect from "react-select/creatable";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import { QuestionarioContext } from "../../../../contexts/QuestionarioContext";
import { PerguntaContext } from "../../../../contexts/PerguntaContext";
import PerguntaService from "../../../../services/PerguntaService";
import { successToast } from "../../../../components/DommusToast";
import DommusRequiredSpan from "../../../../components/DommusRequiredSpan";

export const TipoRespostaEnum = {
  TEXTO: 1,
  DATA : 2,
  CPF : 3,
  CEP : 4,
  TELEFONE : 5,
  MOEDA : 6,
  SIMPLES_SELECAO : 7,
  MULTIPLA_SELECAO : 8,
  CHECKBOX : 9,
}

export function PerguntaForm({ pergunta, closeModal }) {
    const { register, handleSubmit, control, watch } =
        useForm({
            defaultValues: pergunta,
        });
    const { recarregarQuestionarios } = useContext(QuestionarioContext);
    const watchTipoResposta = watch("id_tipo_resposta_pergunta");
    const { listaTipoRespostaPerguntas, atualizarPergunta, adicionarPergunta } = useContext(PerguntaContext);
    const [tipoOptionsRespostas, setTipoOptionsRespostas] = useState("");

    const camposTiposRespostas = useMemo(() => {
        return [
            TipoRespostaEnum.CHECKBOX,
            TipoRespostaEnum.MULTIPLA_SELECAO,
            TipoRespostaEnum.SIMPLES_SELECAO,
        ];
    }, []);

    const handleOnSubmit = (data) => {
        let isUpdate = Boolean(Object.keys(pergunta).length);        
        data.options = tipoOptionsRespostas === "texto" ? [] : (Array.isArray(data.options) && data.options.length ) ? data.options.map((option) => {
            return {
                label: option.label,
                value: option.value,
            }
        }) : data.options;

        let metodo = isUpdate ? PerguntaService.update(pergunta.id_pergunta, data) : PerguntaService.store(data);

        trackPromise(metodo).then((response) => {
            if (isUpdate) {
                atualizarPergunta(response.data);
            } else {
                adicionarPergunta(response.data);
            }
            closeModal();
            successToast.fire("Pergunta salva com sucesso!!");
        }).catch((error) => {
            Swal.fire({
                titleText: "Ooops...",
                text: "Ocorreu um erro ao tentar salvar uma nova pergunta: " + error?.response?.data?.enunciado ?? error,
                icon: "error",
            })
        })
    };

    useEffect(() => {
        if (camposTiposRespostas.includes(Number(watchTipoResposta))) {
            setTipoOptionsRespostas("select");
        }else {
            setTipoOptionsRespostas("texto");
        }
    }, [watchTipoResposta, camposTiposRespostas]);

    return (
        <Form onSubmit={handleSubmit(handleOnSubmit)} className="pergunta-form">
            <Row className="mb-3">
                <Col md="12">
                    <Form.Label>Enunciado: <DommusRequiredSpan /></Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        name="enunciado"
                        {...register("enunciado", {required: true})}
                    />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md="6">
                    <Form.Label>Tipo de Resposta: <DommusRequiredSpan /></Form.Label>
                    <Form.Control
                        as={"select"}
                        name="id_tipo_resposta_pergunta"
                        {...register("id_tipo_resposta_pergunta", {required: true})}
                    >
                        <option value="">Selecione uma opção</option>
                        {listaTipoRespostaPerguntas.map((resposta, index) => {
                            return (
                                <option key={index} value={resposta.id_tipo_resposta_pergunta}>
                                    {resposta.nome}
                                </option>
                            );
                        })}
                    </Form.Control>
                </Col>

                <Col md="6">
                    <Form.Label>Respostas:</Form.Label>
                    <Controller
                        control={control}
                        name={"options"}
                        render={({ field }) => {
                            if (tipoOptionsRespostas === "select") {
                              return (
                                <CreatableSelect
                                  isMulti
                                  {...field}
                                  onChange={(selected) => field.onChange(selected)}
                                  value={field.value || []}
                                  name={"options"}
                                />
                              );                            
                            } else {
                              return (
                                <Form.Control
                                    as="select"
                                    custom
                                    disabled={true}
                                >
                                    <option value="">Não Aplicado</option>
                                </Form.Control>
                              );
                            }
                        }}
                    />
                </Col>
            </Row>
            <Row className="justify-content-end mt-3 mx-2">
                <Button variant="success" type="submit">
                    <FontAwesomeIcon icon={faSave} /> Salvar
                </Button>
            </Row>
        </Form>
    );
}
